var campaignPicker = (function () {
	"use scrict";
	
	var count = 0,
		container = $('.campaign-picker-container');

	container.on('click', function() {

		var $this = $(this),
			countCampaigns = 0,
			countText = $('.countText'),
			article = countText.attr('data-text'),
			articles = countText.attr('data-texts');
		
		if(!$this.hasClass('activeCampaign')) {
			$this.closest('.three-col').find('.activeCampaign').removeClass('activeCampaign');
			$this.addClass('activeCampaign');
		}
		else {
			$this.closest('.three-col').find('.activeCampaign').removeClass('activeCampaign');
		}

		countCampaigns = $('.activeCampaign').length;

		$('.countCampaigns').find('.count').html(countCampaigns);

		if(countCampaigns === 1) {
			countText.html(article);
		}
		else{
			countText.html(articles);
		}
		
		return false;

	});

})();